'use client';

import { FormEvent, ChangeEvent, useState, useEffect } from 'react';
import { IcCircleCancelFill, IcSearch, Typography, theme } from '@bgzt/ui';

import { Input } from '~/components';

import styles from './ShopSearchForm.module.css';

const SHOP_SEARCH_INPUT = {
  NAME: 'shop-search-input',
  MAX_LENGTH: 40,
};

type Props = {
  defaultValue?: string;
  onSubmit?(value: string): void;
  onClick?(): void;
  onCancel?(): void;
  shopName?: string;
};
export const ShopSearchForm = ({ defaultValue, onSubmit, onClick, onCancel, shopName }: Props) => {
  const [value, setValue] = useState('');
  const [isFocus, setIsFocus] = useState(false);
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const inputElement = event.currentTarget.elements.namedItem(SHOP_SEARCH_INPUT.NAME) as HTMLInputElement;
    onSubmit?.(value);
    inputElement?.blur();
  };

  const handleClick = () => {
    onClick?.();
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleClickRemove = () => {
    setValue('');
  };

  const handleClickCancel = () => {
    onCancel?.();
    setValue('');
    setIsFocus(false);
  };

  useEffect(() => {
    if (!defaultValue) return;
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.inputContainer}>
          <IcSearch size={16} fill={theme.colors['gray-200']} className={styles.searchIcon} />
          <Input
            type="search"
            className={styles.input}
            value={value}
            name={SHOP_SEARCH_INPUT.NAME}
            maxLength={SHOP_SEARCH_INPUT.MAX_LENGTH}
            onClick={handleClick}
            onChange={handleChange}
            onFocus={() => setIsFocus(true)}
            placeholder={`${shopName} 상품을 검색해 보세요.`}
            enterKeyHint="search"
          />

          {value.length > 0 && (
            <button type="button" className={styles.removeButton} onClick={handleClickRemove}>
              <IcCircleCancelFill fill={theme.colors['gray-150']} size={16} />
            </button>
          )}
        </div>
        {(isFocus || value.length > 0) && (
          <button type="button" className={styles.cancelButton} onClick={handleClickCancel}>
            <Typography variant={'L7'} color={'gray-900'}>
              취소
            </Typography>
          </button>
        )}
      </form>
    </div>
  );
};
